import apollo from '@/graphql'

import DeviceIssueMetricsQuery from '@/graphql/device_issue/DeviceIssueMetricsQuery.gql'

// initial state
const state = {
  deviceIssueMetrics: {},
}

// getters
const getters = {
  deviceIssueMetrics: st => st.deviceIssueMetrics,
}

// mutations
const mutations = {
  setDeviceIssueMetrics(st, deviceIssueMetrics) {
    state.deviceIssueMetrics = deviceIssueMetrics
  },
}

// actions
const actions = {
  loadDeviceIssueMetrics({ commit }, { filter }) {
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        // Don't use pollInterval here, because it will requery for each
        // combination of filters that is used.
        query: DeviceIssueMetricsQuery,
        variables: { filter: filter || {} },
      })
      .subscribe(({ data: { deviceIssueMetrics } }) => {
        commit('setDeviceIssueMetrics', deviceIssueMetrics)
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/device_issue/DeviceIssueMetrics.js